/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from 'react';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { useSearchParams } from 'react-router-dom';
import { DatePicker, Space } from 'antd';
import CustomDateRangePicker from '../../../components/CustomDateRangePicker';
import { Tooltip } from 'react-tooltip';
import FilterCheckbox from './FilterCheckbox';
const { RangePicker } = DatePicker;
import { dataService } from '../../../services/data.services';
import InfiniteScroll from 'react-infinite-scroll-component';
import EmptyFilterPage from './EmptyFilterPage';
import FilterShimmer from './FilterShimmer';

const OrdersFilter = ({ FilterData,
    setFilterCheckBox,
    handleApplyFilter,
    isFilterOpen,
    setIsFilterOpen,
    handleOnClickSearch,
    handleSetDate,
    DateRange,
    DateRangeError,
    SetDateRangeError,
    DateErrorClear,
    productFilter,
    handleDatePickerValidation,
    filterValues,
    setFilterValues }) => {

    const ref = useRef();
    const [active, setActive] = useState('status')

    const [isStatus, setIsStatus] = useState(true)
    const [isDate, setIsDate] = useState(false)
    const [isStore, setIsStore] = useState(false)
    const [defaultCount, setDefaultCount] = useState();
    const [storePage, setStorePage] = useState(1);
    const [storeData, setStoreData] = useState([])
    const [searchStore, setSearchStore] = useState('');
    const [loading, setLoading] = useState();
    const [showError, setShowError] = useState(false);
    const [debounceTimer, setDebounceTimer] = useState(null);

    const fetchStores = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const response = await dataService.GetAPI(`stores/list?page_number=${pageNumber}`);
            if (pageNumber === 1) {
                setStoreData(response?.data?.data);
            } else {
                setStoreData(prevData => [...prevData, ...response?.data?.data]);
            }
            setDefaultCount(response?.data?.total_count);
            setStorePage(pageNumber);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }

    function handleToggle(type) {
        if (type === 'status') {
            setIsDate(false);
            setIsStore(false);
            setIsStatus(true);
        } else if (type === 'date') {
            setIsDate(true);
            setIsStore(false);
            setIsStatus(false);
        } else if (type === 'store') {
            if (!isStore) {
                setIsDate(false);
                setIsStore(true);
                setIsStatus(false);
                fetchStores(1);
                setStorePage(1);
                setSearchStore('');
            }
        }
    }

    const handleSearch = async (value, pageNumber, key) => {
        setShowError(false);
        const searchValue = encodeURIComponent(value)
        try {
            const response = await dataService.GetAPI(`stores/list?order_filter=true&search=${searchValue}&page_number=${pageNumber}`);
            if (pageNumber === 1 || key === 'search') {
                setStoreData(response?.data?.data);
            } else {
                setStoreData(prevData => [...prevData, ...response?.data?.data]);
            }
            setDefaultCount(response?.data?.total_count)
        } catch (error) {
            setShowError(true);
        }
    }


    const handleChange = (e) => {
        const { value } = e.target;
        setLoading(true)
        setSearchStore(value);
        setStorePage(1);
        setStoreData([]);
        setLoading(false);
        setShowError(false);

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        setLoading(true);

        const timer = setTimeout(async () => {
            try {
                await handleSearch(value, 1, 'search');
            } catch (error) {
            } finally {
                setLoading(false);
                setShowError(true);
            }
        }, 1000);
        setDebounceTimer(timer);
    };

    const updatePage = () => {
        const page = storePage + 1
        setStorePage(page)
        handleSearch(searchStore, page);
    }

    useOnClickOutside(ref, () => {
        DateErrorClear()
        setIsFilterOpen(false)
    })


    const [statusKey, setSatusKey] = useState('')

    const initailState = {
        status: { Completed: false, Pending: false, Failed: false, Partial: false },
        // paymentType: { 'Card Based Payment': false, 'Crypto Based Payment': false },
        // dataRange: { create_start : '', create_end: '' },
    }

    const checkTrueProperties = (obj) => {
        const trueProperties = [];

        for (const key in obj) {
            if (obj[key] === true) {
                trueProperties.push(key);
            }
        }

        return trueProperties.join(',');
    };

    return (
        <div className="relative">
            <img
                src="/assets/images/filter.svg"
                className="cursor-pointer p-3 hover:bg-[#ECD2E0] rounded-full"
                alt=""
                data-testid="filter-btn"
                data-tooltip-id="my-tooltip-14"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
            />
            <Tooltip
                id="my-tooltip-14"
                place="bottom"
                content="Filter"
            />

            {isFilterOpen && <>
                <div ref={ref} className="p-4 absolute w-[550px] top-[40px] right-0 rounded-[4px] flex flex-row  z-10 bg-white border border-[#F7D7E8]">
                    <div className={`flex flex-row justify-between relative z-0`}>
                        <div className='flex flex-col justify-between'>
                            <div>
                                <p data-testid="sub-btn" className={`pb-3 ml-[10px] font-[400] text-base  cursor-pointer ${isStatus ? 'text-[#9E2064]' : 'text-[#000000B1]'}`} onClick={() => handleToggle('status')} >Status</p>
                                <p data-testid={"date-btn"} className={`pb-3 ml-[10px] font-[400] text-base  cursor-pointer ${isDate ? 'text-[#9E2064]' : 'text-[#000000B1]'}`} onClick={() => handleToggle('date')}>Order Date</p>
                                <p data-testid={"store-btn"} className={`pb-3 ml-[10px] font-[400] text-base  cursor-pointer ${isStore ? 'text-[#9E2064]' : 'text-[#000000B1]'}`} onClick={() => handleToggle('store')}>Store Name</p>
                            </div>
                            <div className='mt-3'>
                                <button className='bg-primary px-[47.5px] py-[5px] w-[129px] text-[14px] leading-[22px] font-[400] rounded-[12px] text-[#FFFFFF]' data-testid="apply-btn" onClick={() => {
                                    if (handleDatePickerValidation()) {
                                        return
                                    }
                                    const status = checkTrueProperties(filterValues.status)
                                    const paymentType = checkTrueProperties(filterValues.paymentType)
                                    const store = checkTrueProperties(filterValues.store)
                                    handleApplyFilter(status, false, paymentType, store);
                                    setIsFilterOpen(false)
                                }}>
                                    Apply
                                </button>
                                <button data-testid="clear-btn" className="text-[14px] font-[400] leading-[22px] text-[#731748] whitespace-nowrap mt-3 w-[129px]" onClick={() => {
                                    handleApplyFilter('all', 'clear');
                                    setFilterValues(initailState);
                                    setIsFilterOpen(false)
                                }}>
                                    Clear All
                                </button>
                            </div>
                        </div>

                        <div className='border-l pl-[20px] border-[#EB9DC7]'>

                            <div className='w-full'>
                                {isStatus && <div className="flex flex-col min-w-[348px]">
                                    <h1 className={`font-[400] text-base text-[#000000B1] pb-3`}>
                                        Status
                                    </h1>
                                    <FilterCheckbox id="completed" valueOf='status' checkboxText='Completed' setFilterValues={setFilterValues} filterValues={filterValues} />
                                    <FilterCheckbox id="failed" valueOf='status' checkboxText='Failed' setFilterValues={setFilterValues} filterValues={filterValues} />
                                    <FilterCheckbox id="partial" valueOf='status' checkboxText='Partial' setFilterValues={setFilterValues} filterValues={filterValues} />
                                    <FilterCheckbox id="pending" valueOf='status' checkboxText='Pending' setFilterValues={setFilterValues} filterValues={filterValues} />
                                </div>}
                                {isDate && <div className='relative z-0'>
                                    <p className='pb-3 font-[400] text-base text-[#000000B1]'>Order Date</p>
                                    <div className='relative'>
                                        <CustomDateRangePicker
                                            start='create_start'
                                            end='create_end'
                                            handleSetDate={handleSetDate}
                                            DateRangeError={DateRangeError}
                                            SetDateRangeError={SetDateRangeError}
                                            DateRange={DateRange} />
                                    </div>
                                </div>}
                                {isStore && (
                                    <div className="flex flex-col min-w-[348px]">
                                        <h1 className="font-[400] text-base text-[#000000B1] pb-3">
                                            Store Name
                                        </h1>
                                        <div className="relative ">
                                            <input
                                                type="text"
                                                value={searchStore}
                                                data-testid="fliter-search"
                                                onChange={handleChange}
                                                placeholder="Store Name"
                                                className="w-[343px] rounded-[8px] pr-10 pl-[14px] py-2 z-1 border border-[#8E8E8E] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none"
                                            />
                                            <img
                                                src="/assets/images/search.svg"
                                                alt="Search Icon"
                                                data-testid="fliter-search-btn"
                                                className={`absolute top-[11px] right-[30px] cursor-pointer `}
                                            />
                                            <div className='pt-2'>
                                                <InfiniteScroll
                                                    dataLength={storeData?.length || 0}
                                                    next={updatePage}
                                                    hasMore={defaultCount > storeData?.length}
                                                    height={260}
                                                    useWindow={false}
                                                    scrollThreshold={0.9}
                                                    className='scrollBar'
                                                >
                                                    {loading && storeData.length === 0 ? (
                                                        <FilterShimmer />
                                                    ) : (
                                                        <div>
                                                            {storeData?.map((item, index) => (
                                                                <FilterCheckbox
                                                                    key={item._id}
                                                                    valueOf='store'
                                                                    checkboxText={item.email_address}
                                                                    storeName={item.name.length > 35 ? item.name.slice(0, 35) + '...' : item.name}
                                                                    setFilterValues={setFilterValues}
                                                                    filterValues={filterValues}
                                                                    data-testid={`filter-${index}`}
                                                                    className="block w-full px-[9px] py-2 capitalize text-left hover:bg-[#EB9DC7] focus:outline-none border border-[#CDCDCD] rounded font-normal text-xs text-black truncate"
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                    {storeData?.length === 0 && !loading && showError && (<div className='w-full flex justify-center'><EmptyFilterPage text="We couldn't find what you searched for." subtext="Please try a different search or try again" /></div>)}
                                                </InfiniteScroll>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>}
        </div>
    );
}

export default OrdersFilter;
